import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { PaginationParam } from "daisy-design-system-front";
import {PagingAttributes} from '../../../../swagger-gen/web-secured/models/paging-attributes';
import {MappedExportTemplate} from '../../../models/export-templates/export-template.models';
import {
  SearchExportRequestModels$Json$Params
} from '../../../../swagger-gen/web-secured/fn/reporting/search-export-request-models-json';

export const ExportTemplatesActions = createActionGroup({
  source: "[Export templates]",
  events: {
    Search: props<{filter: SearchExportRequestModels$Json$Params, currentPage: number}>(),
    Fetch: props<PaginationParam>(),
    "loader Start": emptyProps(),
    "Fetch Success": props<{ response: {paging: PagingAttributes, list: Array<MappedExportTemplate>} }>(),
    "Fetch Failure": props<{ message: string }>(),

    "Create Model": props<{ modelName: string, file: File }>(),
    "Create Model Success": props<{ message: string }>(),
    "Create Model Failure": props<{ message: string }>(),

    "Delete Model": props<{ modelUid: string}>(),
    "Delete Model Success": props<{ message: string }>(),
    "Delete Model Failure": props<{ message: string }>(),

    "Download Model": props<{ modelUid: string}>(),
    "Download Model Success": props<{ message: string }>(),
    "Download Model Failure": props<{ message: string }>(),

    "Download Sample Model": emptyProps(),
    "Download Sample Model Success": props<{ message: string }>(),
    "Download Sample Model Failure": props<{ message: string }>(),
  },
});

